import { jsx } from "react/jsx-runtime";
import React, { Fragment, Children } from "react";
import cx from "classnames";
import { useBreakpoint } from "@ingka/viewport-hooks";
const ModalFooter = (props) => {
  const {
    prefix = "",
    children,
    closeBtnClick = () => void 0,
    renderBorder = false,
    className = "",
    stacked = false,
    ...other
  } = props;
  let childrenArr = Children.toArray(children);
  if (childrenArr.length && React.isValidElement(childrenArr[0]) && childrenArr[0].type === Fragment) {
    childrenArr = Children.toArray(
      childrenArr[0].props.children
    );
  }
  const breakpoint = useBreakpoint("sm", "md");
  const classes = cx(
    `${prefix}modal-footer`,
    !renderBorder && `${prefix}modal-footer--borderless`,
    childrenArr.length === 2 && `${prefix}modal-footer--dual-action`,
    stacked && `${prefix}modal-footer--stacked`,
    className
  );
  const buttons = childrenArr.map((item, i) => {
    if (React.isValidElement(item)) {
      const clickHandlerWrapper = item.props.onClick ? (ev) => item.props.onClick && item.props.onClick(ev) : (ev) => closeBtnClick(ev);
      return React.cloneElement(item, {
        prefix,
        small: breakpoint === "sm",
        key: i,
        onClick: clickHandlerWrapper
      });
    }
    return item;
  });
  return /* @__PURE__ */ jsx("div", { className: classes, ...other, children: buttons });
};
var Footer_default = ModalFooter;
export {
  ModalFooter,
  Footer_default as default
};
